import { render, staticRenderFns } from "./CodePage.vue?vue&type=template&id=53f25e9e&scoped=true"
import script from "./CodePage.vue?vue&type=script&lang=js"
export * from "./CodePage.vue?vue&type=script&lang=js"
import style0 from "./CodePage.vue?vue&type=style&index=0&id=53f25e9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f25e9e",
  null
  
)

export default component.exports